import { ReactElement } from 'react';

import { BadgeGiftSvg } from '@cashier/cashier-assets';
import { cn } from '@cashier/cashier-ui';

import { useBonusBadge, useBonusConfiguration } from '../../hooks';

import styles from './styles.module.scss';

interface BonusBadgeProps {
  amount: string;
  variant?: 'inline' | 'floating';
}

export const BonusBadge = ({
  amount,
  variant = 'inline',
}: BonusBadgeProps): ReactElement | null => {
  const { getLabel } = useBonusBadge();
  const { getConfigurationByAmount } = useBonusConfiguration();

  const bonusConfiguration = getConfigurationByAmount(amount);

  if (!bonusConfiguration?.displayFastSums) {
    return null;
  }

  const badgeLabel = getLabel(amount, bonusConfiguration);

  return (
    <div
      className={cn({
        [styles.bonusBadge]: true,
        [styles.inlineBonusBadge]: variant === 'inline',
        [styles.floatingBonusBadge]: variant === 'floating',
      })}
      data-test="bonus-badge"
    >
      {badgeLabel || <BadgeGiftSvg />}
    </div>
  );
};
